import { ProgressIndicator } from '@/components/form/ProgressIndicator.comp.tsx';
import { useLayoutContext } from '@/utils/providers/layoutContext/useUserContext.tsx';
import React from 'react';

interface QuestionProgressProps {
  currentQuestionId?: number | null;
  noOfQuestions?: number;
}

const QuestionProgress: React.FC<QuestionProgressProps> = ({
  currentQuestionId,
  noOfQuestions,
}) => {
  const { fullScreenVideo } = useLayoutContext();

  if (
    fullScreenVideo ||
    !currentQuestionId ||
    !noOfQuestions ||
    currentQuestionId > noOfQuestions
  ) {
    return null;
  }

  return <ProgressIndicator currentProgress={currentQuestionId} maxProgress={noOfQuestions} />;
};

export default QuestionProgress;
